import { isConfirmed } from '../../../functions/sale'
import { PosStateManager } from '../../../managers/pos-state-manager'
import { ReduxCurrentSale } from '../../../state/slices/currentSale/currentSaleSlice'

export const isDiscountDisabled = (
  posStateManager: PosStateManager,
  currentSale: ReduxCurrentSale
) => {
  const isReturn = currentSale && currentSale.returnFor
  const hasActiveSale = Boolean(posStateManager.getActiveSaleLocalId())
  return Boolean(
    isReturn ||
      !hasActiveSale ||
      isConfirmed(currentSale) ||
      currentSale.isSavedUnfulfilled ||
      currentSale.isSavedService
  )
}
